import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'
import fadeIn from '../../../styles/animations/fadeIn'

export const Container = styled.div<{ fullPage?: boolean }>`
  min-height: 100%;
  height: 100%;
  max-width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.secondary || '#b8b8b8'};
  ${down('md')} {
    margin-left: 0px;
  }
  ${({ fullPage }) =>
    fullPage
      ? css`
          padding-top: 0px;
        `
      : css`
          padding: 25px;
          padding-top: 85px;
        `}
`

export const Content = styled.div`
  ${fadeIn};
  display: flex;
  height: -webkit-fill-available;
  width: 100%;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.secondary || '#b8b8b8'};
`
